import { z } from 'zod';
/**
 * Auth Error Codes
 */
export const AuthErrorCode = {
    INVALID_CREDENTIALS: 'AUTH_INVALID_CREDENTIALS',
    TOKEN_EXPIRED: 'AUTH_TOKEN_EXPIRED',
    TOKEN_INVALID: 'AUTH_TOKEN_INVALID',
    REFRESH_TOKEN_EXPIRED: 'AUTH_REFRESH_TOKEN_EXPIRED',
    USER_NOT_FOUND: 'AUTH_USER_NOT_FOUND',
    USER_DISABLED: 'AUTH_USER_DISABLED',
    EMAIL_NOT_VERIFIED: 'AUTH_EMAIL_NOT_VERIFIED',
    OAUTH_FAILED: 'AUTH_OAUTH_FAILED',
};
/**
 * User Error Codes
 */
export const UserErrorCode = {
    EMAIL_ALREADY_EXISTS: 'USER_EMAIL_ALREADY_EXISTS',
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    INVALID_PASSWORD: 'USER_INVALID_PASSWORD',
    WEAK_PASSWORD: 'USER_WEAK_PASSWORD',
};
/**
 * Validation Error Codes
 */
export const ValidationErrorCode = {
    REQUIRED_FIELD: 'VALIDATION_REQUIRED_FIELD',
    INVALID_EMAIL: 'VALIDATION_INVALID_EMAIL',
    INVALID_FORMAT: 'VALIDATION_INVALID_FORMAT',
    TOO_SHORT: 'VALIDATION_TOO_SHORT',
    TOO_LONG: 'VALIDATION_TOO_LONG',
};
/**
 * General Error Codes
 */
export const GeneralErrorCode = {
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    NETWORK_ERROR: 'NETWORK_ERROR',
    NOT_FOUND: 'NOT_FOUND',
    FORBIDDEN: 'FORBIDDEN',
    BAD_REQUEST: 'BAD_REQUEST',
    TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
};
/**
 * All error codes collected for Zod enum
 */
const allErrorCodes = [
    ...Object.values(AuthErrorCode),
    ...Object.values(UserErrorCode),
    ...Object.values(ValidationErrorCode),
    ...Object.values(GeneralErrorCode),
];
function toNonEmptyArray(values) {
    if (values.length === 0) {
        throw new Error('Error codes array must not be empty');
    }
    return [values[0], ...values.slice(1)];
}
/**
 * Combined error codes schema for type safety
 */
export const ErrorCodeSchema = z.enum(toNonEmptyArray(allErrorCodes));
/**
 * All error codes namespace
 */
export const ErrorCodes = {
    Auth: AuthErrorCode,
    User: UserErrorCode,
    Validation: ValidationErrorCode,
    General: GeneralErrorCode,
};
//# sourceMappingURL=error-codes.js.map